import axios from 'axios'

export default class ConversationResource {
  list (page = 1, perPage = 20) {
    return this.search('', page, perPage)
  }

  search (keyword, page = 1, perPage = 20) {
    return axios.get(`/api/conversations/list?search=${keyword}&page=${page}&per_page=${perPage}`)
  }

  messages (conversationId, page = 1, perPage = 20) {
    return axios.get(`/api/conversations/${conversationId}/messages?page=${page}&per_page=${perPage}`)
  }

  sendMessage ({ text, files = [], recipientCode = '' }, conversationId = null) {
    const formData = new FormData()
    formData.append('text', text)
    formData.append('recipient_code', recipientCode)
    for (const file of files) {
      formData.append('files[]', file)
    }

    let url = '/api/conversations'
    if (conversationId) url = url + `/${conversationId}`

    return axios.post(url, formData)
  }

  unreadMessagesCount () {
    return axios.get('/api/conversations/count')
  }

  setSeen (conversationId, conversationMessageId) {
    return axios.get(`/api/conversations/${conversationId}/messages/${conversationMessageId}/seen`)
  }

  downloadFile (fileId) {
    return axios.get(`/api/conversations/download/${fileId}`)
  }

  labSubjects (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/multiple-messages/lab-subjects?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  groups (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/multiple-messages/groups?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  students (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/multiple-messages/students?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }


  persons (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/multiple-messages/persons?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  schoolDepartments (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/multiple-messages/school-departments?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  statuses (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/students/status-types?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  orderNumbers (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/multiple-messages/order-numbers?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  specialities (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/multiple-messages/specialities?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  contracts (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/multiple-messages/contracts?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  staffDepartments (page = 1, perPage = 20, filters = { }, sort = { }) {
    const filterString = new URLSearchParams(filters)
    const sortString = new URLSearchParams(sort)

    return axios.get(`/api/multiple-messages/staff-departments?page=${page}&per_page=${perPage}&${filterString}&${sortString}`)
  }

  sendMultipleToSubject ({ text, files }, subjectId) {
    return this.sendMultiple({ text, files }, `lab_subject_id=${subjectId}`)
  }

  sendMultipleToGroup ({ text, files }, group) {
    return this.sendMultiple({ text, files }, `group=${group}`)
  }

  sendUniqMessagesStudents ({ text, files }, uniqStudents) {
    return this.sendMultiple({ text, files }, `uniqStudents=${uniqStudents}`)
  }
  sendUniqMessagesStaff ({ text, files }, uniqStaff) {
    return this.sendMultiple({ text, files }, `uniqStaff=${uniqStaff}`)
  }


   



  sendMultipleToDepartment ({ text, files }, departmentId) {
    return this.sendMultiple({ text, files }, `school_department_id=${departmentId}`)
  }

  sendMultipleToAllStudent ({ text, files }) {
    return this.sendMultiple({ text, files }, 'all_student=1')
  }

  sendMultipleToAllBachelor ({ text, files }) {
    return this.sendMultiple({ text, files }, 'all_bachelor=1')
  }

  sendMultipleToAllMaster ({ text, files }) {
    return this.sendMultiple({ text, files }, 'all_master=1')
  }

  sendMultipleByStatus ({ text, files }, statusTypeId) {
    return this.sendMultiple({ text, files }, `status_type_id=${statusTypeId}`)
  }

  sendMultipleByOrderNumber ({ text, files }, orderNumber) {
    return this.sendMultiple({ text, files }, `order_number=${orderNumber}`)
  }

  sendMultipleToGeorgian ({ text, files }) {
    return this.sendMultiple({ text, files }, 'georgian_students=1')
  }

  sendMultipleToAbroad ({ text, files }) {
    return this.sendMultiple({ text, files }, 'abroad_students=1')
  }

  sendMultipleToIraqi ({ text, files }) {
    return this.sendMultiple({ text, files }, 'iraqi_students=1')
  }

  sendMultipleBySpeciality ({ text, files }, specialityId) {
    return this.sendMultiple({ text, files }, `speciality_id=${specialityId}`)
  }

  sendMultipleToAllStaff ({ text, files }) {
    return this.sendMultiple({ text, files }, 'all_staff=1')
  }

  sendMultipleToAllLecturer ({ text, files }) {
    return this.sendMultiple({ text, files }, 'all_lecturer=1')
  }

  sendMultipleByContractType ({ text, files }, contractTypeId) {
    return this.sendMultiple({ text, files }, `contract_type_id=${contractTypeId}`)
  }

  sendMultipleByStaffDepartment ({ text, files }, staffDepartmentId) {
    return this.sendMultiple({ text, files }, `staff_department_id=${staffDepartmentId}`)
  }

  sendMultiple ({ text, files }, params) {
    const formData = new FormData()
    formData.append('text', text)
    for (const file of files) {
      formData.append('files[]', file)
    }

    return axios.post(`/api/multiple-messages/send?${params}`, formData)
  }
}
